import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Form, Button, Alert, Space, Row, Input } from 'antd';
import { WarningFilled, DeleteOutlined } from '@ant-design/icons';
import { Modal } from '../../UI/Modal/Modal.component';
import { deleteCustomer, deleteUser } from '../../../services/UserService';
import { USER_TYPE } from '../../../Constants';
import { useNotificationApi } from '../../UI/NotificationProvider';

const { Text, Paragraph } = Typography; 

export const AccessManagementDeleteUserModal = ({user, ...props}) => {

    const { displayModal, setDisplayModal, } = props;

    const navigate = useNavigate();
    const notificationApi = useNotificationApi();

    const [displayErrorMessage, setDisplayErrorMessage] = useState(false);

    const handleDelete = () => {
        let username = user.username;
        let userID = user.id
        let userType = user.userType;

        const handleSuccessResponse = () => {

            setDisplayErrorMessage(false); 

            //  Updates table in access management screen
            if(props.setRefreshData){
                props.setRefreshData(true);
            }

            notificationApi['success']({
                message: 'Success',
                description:
                    `${username} has been successfully deleted.`,
                duration: 6,
            });

            setDisplayModal(false);
            navigate('../access-management');
            return;
        };

        if(userType === USER_TYPE.TECH){
            deleteUser({username, userID}).then(function(response) {
                if(!response.result){
                    setDisplayErrorMessage(true);
                } 
                handleSuccessResponse();
                
            })
        } else if(userType === USER_TYPE.CUSTOMER){
            deleteCustomer({customerUsername: username}).then(response => {
                if(response.result){
                    handleSuccessResponse();
                } else {
                    setDisplayErrorMessage(true);
                }
            })
        }
    };

    const getUserTypeLabel = () => {
        
        let label;

        if(user?.userType === USER_TYPE.TECH){
            label = 'Tech'
        } else if (user?.userType === USER_TYPE.CUSTOMER){
            label = 'Customer'
        } else {
            label = 'User'
        }

        return label;
    }

    return (
        <>
            <Modal
                icon={<WarningFilled/>}
                color="var(--error-color)"
                title={`Delete ${getUserTypeLabel()}`}
                justifyTitle="middle"
                visible={displayModal}
                setVisible={setDisplayModal}
                >

                <Space direction='vertical'>
                
                    { displayErrorMessage ? 
                        <Alert type='error' showIcon description=<Text strong style={{color: "var(--error-color)"}}>Something went wrong trying to delete this user. Please try again.</Text>/>
                        :
                        <Alert
                            type="error"
                            message={<Text strong style={{color: "var(--error-color)"}}>Username:<br/>{user?.username}</Text>}
                            closable={false}
                            style={{textAlign: 'center'}}
                        />
                    }
                    
                    <Paragraph>This action is irreversible and all data associated to this user will be deleted.</Paragraph>
                    <Paragraph>Please type <strong>"DELETE"</strong> to confirm: </Paragraph>
                </Space>

                <Form
                    name='deleteUserForm'
                    autoComplete='off'
                    layout='vertical'
                    preserve={false}
                    onFinish={() => handleDelete()}
                    onFieldsChange={() => setDisplayErrorMessage(false)}
                >
                    <Form.Item 
                        name='delete'
                        rules={[
                            {
                                required: true,
                                validateTrigger: 'onSubmit',
                                validator: (_, value) => {
                                        if(value === 'DELETE'){
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Please enter "DELETE" if you want to proceed.'));
                                    }
                                }
                            ]}
                        >
                        <Input style={{textAlign: 'center', }} onInput={(e) => e.target.value = e.target.value.toUpperCase()}/>
                    </Form.Item>
                    <Row justify='end'>   
                        <Form.Item noStyle>
                            <Space>
                                <Button onClick={() => setDisplayModal(false)}>Cancel</Button>
                                <Button htmlType='submit' type='primary' danger icon={<DeleteOutlined/>}>Yes, delete user</Button>
                            </Space>
                        </Form.Item>
                    </Row>
                </Form>
            </Modal>
        </>
    )
}